/**
 * Dashboard density: comfortable (default) / compact.
 * Persists to localStorage; toggles `html.density-compact` to drive CSS tokens.
 */

export const DENSITY_STORAGE_KEY = "identity_armour_density";
export const DENSITY_CHANGED = "identity-armour:density-changed";

export type DensityPreference = "comfortable" | "compact";

const VALID: DensityPreference[] = ["comfortable", "compact"];

export function getDensityPreference(): DensityPreference {
  if (typeof localStorage === "undefined") return "comfortable";
  const raw = localStorage.getItem(DENSITY_STORAGE_KEY);
  if (raw && VALID.includes(raw as DensityPreference)) {
    return raw as DensityPreference;
  }
  return "comfortable";
}

export function applyDensityToDocument(density: DensityPreference): void {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("density-compact", density === "compact");
}

export function setDensityPreference(density: DensityPreference): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(DENSITY_STORAGE_KEY, density);
  applyDensityToDocument(density);
  window.dispatchEvent(new CustomEvent(DENSITY_CHANGED, { detail: { density } }));
}

export function toggleDensity(current: DensityPreference): DensityPreference {
  return current === "comfortable" ? "compact" : "comfortable";
}
